// extracted by mini-css-extract-plugin
module.exports = {"minHeight":"MandatoryQuestion_minHeight__da0vx","text":"MandatoryQuestion_text__1_nVR","icon":"MandatoryQuestion_icon__mt3Vb"};